import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { games } from "@/lib/mock-data";
import { showSuccess } from "@/utils/toast";

const Export = () => {
  const [selectedGameId, setSelectedGameId] = useState<string | undefined>();
  const [selectedVersionId, setSelectedVersionId] = useState<string | undefined>();
  const [selectedFileId, setSelectedFileId] = useState<string | undefined>();
  const [selectedLanguage, setSelectedLanguage] = useState<string | undefined>();

  const selectedGame = games.find((g) => g.id === selectedGameId);
  const selectedVersion = selectedGame?.versions.find((v) => v.id === selectedVersionId);

  const handleGameChange = (gameId: string) => {
    setSelectedGameId(gameId);
    setSelectedVersionId(undefined);
    setSelectedFileId(undefined);
    setSelectedLanguage(undefined);
  };

  const handleVersionChange = (versionId: string) => {
    setSelectedVersionId(versionId);
    setSelectedFileId(undefined);
    setSelectedLanguage(undefined);
  };

  const handleSubmit = () => {
    // Szimuláljuk a mentést
    console.log({
      game: selectedGame?.name,
      version: selectedVersion?.versionNumber,
      file: selectedFileId === 'all' ? 'Minden fájl' : selectedVersion?.files.find(f => f.id === selectedFileId)?.name,
      language: selectedLanguage,
    });
    showSuccess("A fordítás mentése sikeresen megtörtént (szimuláció)!");
  };

  return (
    <div className="max-w-2xl mx-auto">
      <Card>
        <CardHeader>
          <CardTitle>Fordítás Mentése</CardTitle>
          <CardDescription>
            Válaszd ki a menteni kívánt játékot, verziót, fájlt és nyelvet.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="space-y-2">
            <Label>1. Melyik játékból akarsz mentést készíteni?</Label>
            <Select onValueChange={handleGameChange} value={selectedGameId}>
              <SelectTrigger>
                <SelectValue placeholder="Válassz egy játékot..." />
              </SelectTrigger>
              <SelectContent>
                {games.map((game) => (
                  <SelectItem key={game.id} value={game.id}>
                    {game.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          {selectedGame && (
            <div className="space-y-2">
              <Label>2. Melyik verzióból?</Label>
              <Select onValueChange={handleVersionChange} value={selectedVersionId}>
                <SelectTrigger>
                  <SelectValue placeholder="Válassz egy verziót..." />
                </SelectTrigger>
                <SelectContent>
                  {selectedGame.versions.map((version) => (
                    <SelectItem key={version.id} value={version.id}>
                      {version.versionNumber}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          )}

          {selectedVersion && (
            <div className="space-y-2">
              <Label>3. Melyik fájlból?</Label>
              <Select onValueChange={setSelectedFileId} value={selectedFileId}>
                <SelectTrigger>
                  <SelectValue placeholder="Válassz egy fájlt..." />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">Minden fájl</SelectItem>
                  {selectedVersion.files.map((file) => (
                    <SelectItem key={file.id} value={file.id}>
                      {file.name}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          )}

          {selectedFileId && (
             <div className="space-y-2">
                <Label>4. Melyik nyelvet szeretnéd menteni?</Label>
                <Select onValueChange={setSelectedLanguage} value={selectedLanguage}>
                    <SelectTrigger>
                        <SelectValue placeholder="Válassz nyelvet..." />
                    </SelectTrigger>
                    <SelectContent>
                        <SelectItem value="hu">Magyar (HU)</SelectItem>
                        <SelectItem value="de">Német (DE)</SelectItem>
                        <SelectItem value="en">Angol (EN)</SelectItem>
                    </SelectContent>
                </Select>
             </div>
          )}
        </CardContent>
        <CardFooter>
          <Button 
            onClick={handleSubmit} 
            disabled={!selectedGameId || !selectedVersionId || !selectedFileId || !selectedLanguage}
          >
            Mentés
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
};

export default Export;